import {
  PayClassificationVariation,
  transformVariationOnGet,
} from './variation'
import { PayClassificationType } from '$constants'
import { SelectOption, IPayClassificationResponse } from '$models'

export type {
  IPayClassificationResponse,
  IPayClassificationRequest,
} from '@loadedhub/core-api-sdk'
export { PayClassificationRequest } from '@loadedhub/core-api-sdk'

export interface PayClassification
  extends Omit<IPayClassificationResponse, 'variations'> {
  variations: PayClassificationVariation[]
}

// Function to apply transformations to PayClassification object
export const transformPayClassificationOnGet = (
  payClassification: IPayClassificationResponse
): PayClassification => {
  return {
    ...payClassification,
    datestampDeleted: payClassification.datestampDeleted,
    variations: payClassification.variations!.map(transformVariationOnGet),
  }
}

export const newPayClassification: PayClassification = {
  name: '',
  baseHourlyRate: 0,
  isActive: true,
  type: PayClassificationType.Custom,
  variations: [],
}

export const getPayClassificationsAsOptions = (
  payClassifications: PayClassification[]
): SelectOption[] =>
  payClassifications.map((payClassification) => {
    return {
      label: payClassification.name,
      value: payClassification.id!,
    }
  })
